import BaseWidgetController from './base_widget_controller';

export default class extends BaseWidgetController {
  static targets = [...BaseWidgetController.targets, 'total', 'average'];

  static values = {
    ...BaseWidgetController.values,
    averageText: String,
  };

  connect() {
    super.connect();
    this.isFirstLoad = true;
  }

  renderData(data) {
    const delay = this.isFirstLoad ? 0 : 150;
    this.isFirstLoad = false;

    setTimeout(() => {
      this.hideLoading();
      this.hideError();

      if (this.hasTotalTarget) {
        this.totalTarget.textContent = this.formatNumber(data.total);
      }

      if (this.hasAverageTarget) {
        this.averageTarget.textContent = this.averageTextValue.replace(
          /%{average}/g,
          data.average_per_program
        );
      }
    }, delay);
  }

  showLoading() {
    if (this.hasTotalTarget) {
      this.totalTarget.classList.add('opacity-50', 'transition-opacity', 'duration-200');
    }
    if (this.hasAverageTarget) {
      this.averageTarget.classList.add('opacity-50', 'transition-opacity', 'duration-200');
    }
  }

  hideLoading() {
    if (this.hasTotalTarget) {
      this.totalTarget.classList.remove('opacity-50');
    }
    if (this.hasAverageTarget) {
      this.averageTarget.classList.remove('opacity-50');
    }
  }
}